module.exports = __webpack_public_path__ + "static/media/logo-white-gradient.202490e2.png";